import { Component } from "react"
import PropTypes from "prop-types"

import Spinner from "shared/components/spinner"
import ServiceSelector from "./service_selector"
import SelectedService from "./selected_service"
import PlatformSuggestion from "app/components/platform_feedback/platform_suggestion"
import ErrorBoundary from "shared/components/error_boundary"

import { get } from "shared/lib/api"
import { loadPrivateServices } from "./gql"
import {
  logRejectedXHRPromise,
  rejectedXHRPromiseLogger,
} from "shared/lib/xhr_promise"

import { serviceComposerShape } from "partners/components/shared/shared_prop_types"

import "./connection_start_screen.scss"

export default class ConnectionStartScreen extends Component {
  state = {
    services: [],
    loading: true,
    selectedService: null,
    isValid: null,
    submitting: false,
  }

  componentDidMount() {
    loadPrivateServices()
      .then(privateServices => {
        let allServices = privateServices
          .concat(this.props.preloadedServices)
          .filter(s => s.connect_enabled)
          .filter(s => s.module_name !== this.props.ownerServiceSlug)

        this.setState({ services: allServices }, () => {
          this.setState({ loading: false })
        })
      })
      .catch(
        rejectedXHRPromiseLogger(() => {
          window.appendFlash(
            "Could not load services - please check your internet connection",
            "danger"
          )
        })
      )
  }

  onServiceSelect = service => {
    this.setState({ selectedService: service })
  }

  onServiceDeselect = () => {
    this.setState({ selectedService: null })
  }

  onContinueClick = () => {
    this.setState({ submitting: true }, () => {
      get(this.props.urls.validationPath, {
        targeted_service_slug: this.state.selectedService.module_name,
      })
        .then(() => {
          this.setState({ isValid: true }, () => {
            location.replace(
              `${this.props.urls.nextStepPath}?selected_service=${this.state.selectedService.module_name}`
            )
          })
        })
        .catch(({ response, status, error }) => {
          if (response.data === "connection_exists") {
            window.appendFlash(
              "There's an existing connection to the selected service",
              "danger"
            )
          } else {
            logRejectedXHRPromise(response, status, error)
            window.appendFlash("An error occurred", "danger")
          }
        })
        .finally(() => this.setState({ submitting: false }))
    })
  }

  render() {
    return (
      <div className="form" styleName="connection-start">
        {this.state.loading ? (
          <div className="spinner">
            <Spinner />
          </div>
        ) : (
          <div className="fieldset composer-fieldset">
            <div className="partners-service-composer field">
              <div className="label">Choose a service to connect to</div>
              <>
                <ErrorBoundary>
                  <section className="form-section">
                    {this.state.selectedService ? (
                      <SelectedService
                        service={this.state.selectedService}
                        onServiceDeselect={this.onServiceDeselect}
                      />
                    ) : (
                      <ServiceSelector
                        services={this.state.services}
                        onServiceSelect={this.onServiceSelect}
                      />
                    )}
                  </section>
                </ErrorBoundary>

                <div styleName="suggestion-container">
                  <PlatformSuggestion
                    suggestionType="service"
                    displayInline={true}
                  />
                </div>
                {this.state.selectedService && (
                  <div className="continue">
                    <button
                      className="button-secondary"
                      title="Click to continue"
                      aria-label="Click to continue"
                      onClick={this.onContinueClick}
                    >
                      Continue
                    </button>
                  </div>
                )}
              </>
            </div>
          </div>
        )}
      </div>
    )
  }
}

ConnectionStartScreen.propTypes = {
  urls: PropTypes.shape({
    nextStepPath: PropTypes.string,
    validationPath: PropTypes.string,
  }),
  preloadedServices: PropTypes.arrayOf(serviceComposerShape.isRequired),
  ownerServiceSlug: PropTypes.string.isRequired,
}
